<template>
  <div>
    <AdminNav />
    <div class="page">
      <div class="page-header">
        <h2 class="page-title">Gestion commerçants</h2>
        <button class="btn btn-primary" style="width:auto;padding:10px 20px" @click="popupCreer = true">+ Nouveau commerçant</button>
      </div>

      <div class="card">
        <table class="table">
          <thead>
            <tr>
              <th>Enseigne</th>
              <th>Téléphone</th>
              <th>Points/€</th>
              <th>Seuil</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in commercants" :key="c.id">
              <td><strong>{{ c.nom_enseigne }}</strong></td>
              <td class="mono">{{ c.telephone }}</td>
              <td>{{ c.points_par_euro }} pts</td>
              <td>{{ c.seuil_points }} pts</td>
              <td><span class="badge" :class="c.actif ? 'badge-green' : 'badge-red'">{{ c.actif ? 'Actif' : 'Inactif' }}</span></td>
              <td class="actions-cell">
                <button class="btn-action" @click="reinitialiserPin(c, 'connexion')" :disabled="resetEnCours">
                  Réinitialiser PIN
                </button>
                <button class="btn-action" @click="reinitialiserPin(c, 'parametres')" :disabled="resetEnCours">
                  Réinitialiser PIN paramètres
                </button>
                <button class="btn-action edit" title="Modifier" aria-label="Modifier" @click="editer(c)">✏️</button>
                <button class="btn-action delete" title="Désactiver" aria-label="Désactiver" @click="desactiver(c.id)">🗑️</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Popup créer -->
      <div class="modal-overlay" v-if="popupCreer" @click.self="popupCreer = false">
        <div class="modal">
          <h3>Nouveau commerçant</h3>
          <div class="form-group"><label class="label">Nom enseigne</label><input v-model="form.nom_enseigne" class="input" /></div>
          <div class="form-group"><label class="label">Téléphone</label><input v-model="form.telephone" class="input" /></div>
          <div class="form-group"><label class="label">PIN (4 chiffres)</label><input v-model="form.pin" class="input" type="password" maxlength="4" /></div>
          <p v-if="erreur" class="error">{{ erreur }}</p>
          <div class="modal-actions">
            <button class="btn btn-secondary" @click="popupCreer = false">Annuler</button>
            <button class="btn btn-primary" @click="creer">Créer</button>
          </div>
        </div>
      </div>

      <!-- Popup éditer -->
      <div class="modal-overlay" v-if="popupEditer" @click.self="popupEditer = false">
        <div class="modal">
          <h3>Modifier commerçant</h3>
          <div class="form-group"><label class="label">Nom enseigne</label><input v-model="formEdit.nom_enseigne" class="input" /></div>
          <div class="form-group"><label class="label">Téléphone</label><input v-model="formEdit.telephone" class="input" /></div>
          <div class="form-group"><label class="label">Nouveau PIN (optionnel)</label><input v-model="formEdit.pin" class="input" type="password" maxlength="4" /></div>
          <div class="form-group">
            <label class="label">Statut</label>
            <select v-model="formEdit.actif" class="input">
              <option :value="true">Actif</option>
              <option :value="false">Inactif</option>
            </select>
          </div>
          <div class="modal-actions">
            <button class="btn btn-secondary" @click="popupEditer = false">Annuler</button>
            <button class="btn btn-primary" @click="sauvegarder">Sauvegarder</button>
          </div>
        </div>
      </div>

      <div class="modal-overlay" v-if="pinTemporaire" @click.self="fermerPinTemporaire">
        <div class="modal" role="dialog" aria-modal="true" aria-labelledby="temporary-pin-title">
          <h3 id="temporary-pin-title">PIN temporaire</h3>
          <p class="temporary-pin-help">
            PIN {{ pinTemporaire.type }} de <strong>{{ pinTemporaire.nom }}</strong>.
            Il ne sera plus affiché après la fermeture.
          </p>
          <div class="temporary-pin">{{ pinTemporaire.valeur }}</div>
          <p v-if="copieStatut" class="copy-status">{{ copieStatut }}</p>
          <div class="modal-actions">
            <button class="btn btn-secondary" @click="copierPin">Copier le PIN</button>
            <button class="btn btn-primary" @click="fermerPinTemporaire">Fermer</button>
          </div>
        </div>
      </div>

      <p v-if="erreurReset" class="reset-error">{{ erreurReset }}</p>

    </div>
  </div>
</template>

<script>
import AdminNav from '../../components/AdminNav.vue'
import adminApi from '../../adminApi'

export default {
  name: 'AdminCommercants',
  components: { AdminNav },
  data() {
    return {
      commercants: [],
      popupCreer:  false,
      popupEditer: false,
      form:     { nom_enseigne: '', telephone: '', pin: '' },
      formEdit: { id: '', nom_enseigne: '', telephone: '', pin: '', actif: true },
      erreur: '',
      erreurReset: '',
      resetEnCours: false,
      pinTemporaire: null,
      copieStatut: ''
    }
  },
  methods: {
    async charger() {
      try { const res = await adminApi.get('/commercants'); this.commercants = res.data } catch {}
    },
    async creer() {
      this.erreur = ''
      try {
        await adminApi.post('/commercants', this.form)
        this.popupCreer = false
        this.form = { nom_enseigne: '', telephone: '', pin: '' }
        await this.charger()
      } catch (err) { this.erreur = err.response?.data?.error || 'Erreur' }
    },
    editer(c) {
      this.formEdit = { id: c.id, nom_enseigne: c.nom_enseigne, telephone: c.telephone, pin: '', actif: c.actif }
      this.popupEditer = true
    },
    async sauvegarder() {
      try {
        await adminApi.put(`/commercants/${this.formEdit.id}`, this.formEdit)
        this.popupEditer = false
        await this.charger()
      } catch {}
    },
    async desactiver(id) {
      if (!confirm('Désactiver ce commerçant ?')) return
      try { await adminApi.delete(`/commercants/${id}`); await this.charger() } catch {}
    },
    async reinitialiserPin(commercant, type) {
      const libelle = type === 'parametres' ? 'PIN paramètres' : 'PIN de connexion'
      if (!confirm(`Réinitialiser le ${libelle} de ${commercant.nom_enseigne} ?`)) return

      this.erreurReset = ''
      this.resetEnCours = true
      try {
        const suffixe = type === 'parametres' ? 'reset-pin-parametres' : 'reset-pin'
        const res = await adminApi.patch(`/commercants/${commercant.id}/${suffixe}`)
        this.pinTemporaire = {
          valeur: res.data.temporaryPin,
          nom: commercant.nom_enseigne,
          type: type === 'parametres' ? 'paramètres' : 'de connexion'
        }
        this.copieStatut = ''
      } catch (err) {
        this.erreurReset = err.response?.data?.error || 'Impossible de réinitialiser le PIN'
      } finally {
        this.resetEnCours = false
      }
    },
    async copierPin() {
      if (!this.pinTemporaire) return
      try {
        await navigator.clipboard.writeText(this.pinTemporaire.valeur)
        this.copieStatut = 'PIN copié.'
      } catch {
        this.copieStatut = 'Copie impossible. Sélectionnez le PIN manuellement.'
      }
    },
    fermerPinTemporaire() {
      this.pinTemporaire = null
      this.copieStatut = ''
    }
  },
  mounted() { this.charger() }
}
</script>

<style scoped>
.page { width: 100%; max-width: 1280px; margin: 0 auto; padding: 24px; box-sizing: border-box; }
.page-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.page-title { font-size: 22px; font-weight: 700; }
.card { background: white; border-radius: 14px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.table { width: 100%; border-collapse: collapse; font-size: 14px; }
.table th { text-align: left; padding: 10px 12px; font-size: 12px; color: #718096; border-bottom: 2px solid #e2e8f0; }
.table td { padding: 12px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; }
.table tr:hover td { background: #f7fafc; }
.mono { font-family: monospace; }
.badge { padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; }
.badge-green { background: #c6f6d5; color: #22543d; }
.badge-red { background: #fed7d7; color: #742a2a; }
.actions-cell { display: flex; flex-wrap: wrap; gap: 6px; min-width: 330px; }
.btn-action { background: none; border: 1.5px solid #e2e8f0; border-radius: 8px; padding: 6px 10px; cursor: pointer; font-size: 14px; transition: all 0.2s; }
.btn-action:hover { background: #f7fafc; }
.btn-action:disabled { cursor: wait; opacity: 0.55; }
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 200; padding: 20px; }
.modal { background: white; border-radius: 16px; padding: 28px; max-width: 420px; width: 100%; }
.modal h3 { font-size: 18px; font-weight: 700; margin-bottom: 16px; }
.form-group { margin-bottom: 14px; }
.label { display: block; font-size: 13px; font-weight: 600; color: #4a5568; margin-bottom: 5px; }
.input { width: 100%; padding: 10px 14px; border: 1.5px solid #e2e8f0; border-radius: 10px; font-size: 14px; outline: none; }
.error { color: #e53e3e; font-size: 13px; margin-bottom: 10px; }
.modal-actions { display: flex; gap: 10px; margin-top: 16px; }
.btn { padding: 10px 20px; border-radius: 10px; border: none; font-size: 14px; font-weight: 600; cursor: pointer; flex: 1; }
.btn-primary { background: #2d3748; color: white; }
.btn-secondary { background: #edf2f7; color: #4a5568; }
.temporary-pin-help { color: #4a5568; font-size: 14px; line-height: 1.5; }
.temporary-pin { margin: 20px 0 10px; padding: 16px; border-radius: 10px; background: #edf2f7; font-family: monospace; font-size: 32px; font-weight: 700; letter-spacing: 8px; text-align: center; user-select: all; }
.copy-status { color: #2f855a; font-size: 13px; text-align: center; }
.reset-error { position: fixed; right: 24px; bottom: 24px; z-index: 150; max-width: 420px; margin: 0; padding: 12px 16px; border-radius: 10px; background: #fff5f5; color: #c53030; box-shadow: 0 4px 16px rgba(0,0,0,0.12); }
@media (max-width: 600px) { .page { padding: 16px; } }
</style>
